import { useSyncUsersStatusQuery } from '../../gpanel-contacts-queries';
import { useParams } from 'react-router-dom';
import SharedBackButton from '../../shared/components/shared-back-button.tsx';
import GpanelContactsSyncUsersStatusPage from './gpanel-contacts-sync-users-status.tsx';
import Stack from '@mui/material/Stack';

export default function GpanelContactsUsersStatusSync() {
  const syncId = useParams().syncId!;

  const query = useSyncUsersStatusQuery(syncId);

  return (
    <Stack width={1} sx={{ flex: 1, height: 1, overflow: 'hidden' }}>
      <SharedBackButton to="../.." />
      <GpanelContactsSyncUsersStatusPage
        key={query.dataUpdatedAt}
        title={`Destination Users Status`}
        query={query}
      />
    </Stack>
  );
}
